<div class="category-container">
    <div class="wrapper">
            <div *ngFor="let category of categories" class="foo">
                <div class="category-image-container">
                    <img [src]="category.figPath" (click)="setStorybookCategory(category.name)">
                    <div class="category-name text-primary-500">{{category.name | translate}}</div>
                </div>
            </div>
    </div>
</div>
